import Vue from 'vue';

import Step7Questionnaire from './Step7Questionnaire.vue';

// Module styles
import '../questionnaire.scss';

export default el =>
  new Vue({
    el,
    render: h => h(Step7Questionnaire),
  });
